import React from 'react';
import PropTypes from 'prop-types';
import BaseCell from '../base-cell/index';

export default class SystemCell extends BaseCell {

  render() {
    const {text} = this.props;
    return (
      <div className={'cu-ui-message cu-ui-message-sytem cu-ui-text-count-data'} { ...this.textCountCustomAttributes }>
        {text}
      </div>
    );
  }
}

SystemCell.propTypes = {
  text: PropTypes.string
};
